import type { TrainingLessonSpecific } from './trainingLessonUi';

export const deacon1DutiesEn: TrainingLessonSpecific = {
  intro:
    'The office of deacon is the first step in the Aaronic Priesthood. In this lesson you will learn key duties, reverence, and the attitude of service that mark a worthy deacon.',
  objectives: [
    'Understand the purpose of the office of deacon.',
    'Identify key duties of a deacon in the ward.',
    'Learn reverence and appropriate conduct in sacrament meeting.',
    'Understand why “being a deacon” is about serving, not “having a position.”',
    'Set a simple weekly plan to fulfill duties with dignity.',
  ],
  briefHeading: 'Deacon duties in brief',
  briefBody:
    'A deacon helps the bishop and ward leaders. Duties include attending meetings, preparing the chapel, passing the sacrament, and serving in order. Being a deacon is not “having a position”: it is representing the Savior through humble service and reverence.',
  scriptures: [
    { ref: 'D&C 20:59', text: '…to watch over the church… and be with and strengthen it.' },
    { ref: 'D&C 84:111', text: '…the lesser, or Aaronic Priesthood… for the ministration of angels…' },
    { ref: 'Mosiah 2:17', text: '…when ye are in the service of your fellow beings ye are only in the service of your God.' },
    { ref: 'D&C 107:85–87', text: 'The duty of a deacon is to assist…' },
    { ref: '1 Timothy 3:8–10', text: '…grave, not doubletongued… holding the mystery of the faith in a pure conscience.' },
  ],
  didYouKnow: [
    'A deacon does not “just pass the sacrament”: he represents a ministry of help and order in the Church.',
    'Reverence is part of the duty: not mere formality, but respect for covenants.',
  ],
  practiceItems: [
    'Arrive 10 minutes early and sit ready without distractions (one Sunday)',
    'Review appearance: clean, neat clothes; calm attitude',
    'Identify one way to help leaders (order/chairs/hymnals/doors)',
    'During the meeting: no chatting, no phone games, eyes forward',
    'Write down one message idea to improve this week',
    'Do a simple act of service at home without being asked',
  ],
  reflectionQuestions: [
    'What does “representing the Savior” in an office mean to me?',
    'What distracts me most in the meeting? What will I do about it?',
    'Who can I serve simply this week?',
  ],
  actionText:
    'Sunday plan: pick one concrete way to prepare better (e.g., sleep earlier Saturday, lay out clothes, read one scripture before church).',
};
